import React, { useState, useEffect } from "react";
import axios from "axios";
import OrderDetailsModal from "./OrderDetailsModal";
import { useAuth } from "../AuthContext"; // Assume this is your Auth context
import "./Orders.css";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const { mobile } = useAuth(); // Assuming your auth context provides mobile

  useEffect(() => {
    if (mobile) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/api/orders/completed/${mobile}`)
        .then((response) => {
          // Sort orders by date in descending order
          const sortedOrders = response.data.orders.sort(
            (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
          );
          setOrders(sortedOrders);
        })
        .catch((error) => {
          console.error("Error fetching orders:", error);
        });
    }
  }, [mobile]);

  return (
    <div className="orders-container">
      <h2 className="orders-heading">Your Orders</h2>
      {orders.length > 0 ? (
        <ul className="orders-list">
          {orders.map((order) => (
            <li
              key={order.order_id}
              onClick={() => setSelectedOrder(order)}
              className="order-item"
            >
              <div className="order-details">Order ID: {order.order_id}</div>
              <div className="order-details">
                {new Date(order.timestamp).toLocaleDateString()}
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p className="no-orders-message">
          You have no past orders. Kindly go to products page and start
          ordering.
        </p>
      )}
      {selectedOrder && (
        <OrderDetailsModal
          order={selectedOrder}
          onClose={() => setSelectedOrder(null)}
        />
      )}
    </div>
  );
};

export default Orders;
